// extracted by mini-css-extract-plugin
module.exports = {"menuText":"#fff","menuActiveText":"#fff","subMenuActiveText":"#fff","menuBg":"#0d70e3","menuHover":"#0f67d2","subMenuBg":"#0f60c1","subMenuHover":"#0c56af","sideBarWidth":"210px"};